import ValueTracker from "../../prop-trackers/value-tracker.js";
import ValueTrackerObjGen from "../../prop-tracker-utils/value-tracker-obj-gen.js";

class ObjectOnScreenPositions {
    constructor(wrapCtx, evtCtx) {
        this._posTracker = new ValueTracker();
        this._posGen = new ValueTrackerObjGen(wrapCtx, evtCtx, this._posTracker);
    }

    get positions() { return this._posGen; }

    track(labelPositions) {
        if (labelPositions) {
            this._posTracker.setValue(labelPositions);
        } else {
            this._posTracker.deleteValue();
        }
    }

    update() {
        this._posGen.update();
    }
}

export default ObjectOnScreenPositions;
